export default __webpack_public_path__ + "static/media/mentorx.720a8da5.png";